import { render } from "./DocumentsHistoryDialog.vue?vue&type=template&id=f15f819e&scoped=true&ts=true"
import script from "./DocumentsHistoryDialog.vue?vue&type=script&lang=ts"
export * from "./DocumentsHistoryDialog.vue?vue&type=script&lang=ts"

import "./DocumentsHistoryDialog.vue?vue&type=style&index=0&id=f15f819e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f15f819e"]])

export default __exports__
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QSpinnerFacebook from 'quasar/src/components/spinner/QSpinnerFacebook.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QIcon,QSpinnerFacebook,QBtn});
